// extracted by mini-css-extract-plugin
export default {"fillWindow":"styles_fillWindow__CWFtH"};